import uncheckedBg from 'pages/common/subscriptionType/images/unchecked.svg';
import checkedBg from 'pages/common/subscriptionType/images/checked.svg';
import { DEFAULT_FONTFAMILY } from 'theme/theme';

export default {
  SubscriptionType: {
    border: '2px solid #D2D3D5',
    padding: [30, 20, 30, 60],
    display: 'grid',
    marginTop: 20,
    font: `400 14px/16px ${DEFAULT_FONTFAMILY}`,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    background: {
      image: `url("${uncheckedBg}")`,
      repeat: 'no-repeat',
      position: '18px center',
    },
    gridTemplateColumns: '135px 1fr 120px',
    gridTemplateRows: '27px 24px 40px',
    gridTemplateAreas: `
      "title star price"
      "valuations valuations valuations"
      "descriptionPrice descriptionPrice descriptionPrice"`,
    alignItems: 'start',
    '&.active': {
      border: '2px solid #304C95',
      backgroundImage: `url("${checkedBg}")`,
    },
    '&.disabled': {
      opacity: 0.5,
      cursor: 'default',
    },
    '@media screen and (max-width: 1205px)': {
      gridTemplateRows: '27px 36px 40px',
      paddingBottom: 20,
    },
    '&.SUBSCRIPTION_TYPE_ENTERPRISE': {
      gridTemplateAreas: '"title price"',
      alignItems: 'center',
      gridTemplateRows: '100%',
    },
    '@media screen and (max-width: 1040px)': {
      paddingRight: 10,
      paddingLeft: 50,
      backgroundPosition: '15px center',
      '&.SUBSCRIPTION_TYPE_ENTERPRISE': {
        gridTemplateAreas: '"title price"',
        gridTemplateRows: '27px 26px',
        paddingTop: 30,
        paddingBottom: 30,
      },
    },
    '@media screen and (max-width: 1023px)': {
      paddingLeft: 60,
      backgroundPosition: '18px center',
    },
    '@media screen and (max-width: 840px)': {
      '&.SUBSCRIPTION_TYPE_ENTERPRISE': {
        gridTemplateAreas: '"title title" "price price"',
        gridTemplateRows: '27px 36px 36px',
      },
    },
    '@media screen and (max-width: 768px)': {
      '&.AccountPage': {
        paddingTop: 20,
        paddingBottom: 15,
        gridTemplateRows: '27px max-content max-content max-content',
        gridTemplateColumns: '1fr 115px',
        gridTemplateAreas: `
          "title star"
          "price price"
          "valuations valuations"
          "descriptionPrice descriptionPrice"`,
      },
    },
    '@media screen and (max-width: 350px)': {
      '&.AccountPage': {
        gridTemplateRows: '27px max-content max-content max-content max-content',
        gridTemplateColumns: '1fr',
        gridTemplateAreas: `
          "title"
          "price"
          "star"
          "valuations"
          "descriptionPrice"`,
      },
    },
  },
  title: {
    font: `600 18px/18px ${DEFAULT_FONTFAMILY}`,
    gridArea: 'title',
    minWidth: 0,
  },
  mostPopular: {
    gridArea: 'star',
    '@media screen and (max-width: 768px)': {
      marginBottom: 5,
    },
  },
  descriptionPrice: {
    font: `400 12px/15px ${DEFAULT_FONTFAMILY}`,
    whiteSpace: 'nowrap',
    gridArea: 'descriptionPrice',
    minWidth: 0,
    '@media screen and (max-width: 768px)': {
      whiteSpace: 'normal',
    },
    '@media screen and (max-width: 319px)': {
      whiteSpace: 'normal',
    },
  },
  valuations: {
    extend: 'descriptionPrice',
    gridArea: 'valuations',
    fontWeight: 600,
    fontStyle: 'italic',
    minWidth: 0,
    '@media screen and (max-width: 768px)': {
      whiteSpace: 'normal',
    },
  },
  yearPriceWrapper: {
    textAlign: 'center',
    gridArea: 'price',
    minWidth: 0,
    '@media screen and (max-width: 768px)': {
      '&.AccountPage': {
        textAlign: 'left',
        paddingBottom: 7,
      },
    },
  },
  yearPrice: {
    font: `600 16px/19px ${DEFAULT_FONTFAMILY}`,
  },
  yearPricePeriod: {
  },
};
